@if (loadingCategories$ | async) {
  <div class="text-center my-3">
    <app-loading></app-loading>
  </div>
}

@let isArabic = isArabic$ | async;

<div class="d-flex align-items-baseline">
  <i
    class="bi h2 cursor-poiner text-primary bg-dark rounded"
    [ngClass]="isArabic ? 'bi-arrow-right-short ms-2' : 'bi-arrow-left-short me-2'"
    (click)="goBack()"
  ></i>
  <h2 class="mb-0">
    {{ 'CAR_SEARCH_TITLE' | translate }}
  </h2>
</div>

@if (categories$ | async; as categories) {
  <form
    searchCountSummary="CAR"
    [countForm]="searchForm"
    [countFeatures]="advancedVisible"
    #liveCounts="searchCounts"
    [formGroup]="searchForm"
    (ngSubmit)="onSearch()"
    class="p-4 bg-dark rounded"
  >
    <!-- Basic search fields -->
    <div class="row mb-3">
      <div class="col-lg-6 col-md-12 pb-3">
        <div
          class="up-in-toggle search-sale-toggle"
          [ngClass]="isArabic ? 'float-end' : 'float-start'"
        >
          <input
            type="radio"
            id="switch_right"
            name="isForRent"
            [value]="true"
            formControlName="isForRent"
            (click)="toggleIsRent(true)"
          />
          <label for="switch_right"
            ><span class="sale-option-label">{{ 'FOR_RENT' | translate }}</span>
            <small
              class="search-inline-count px-2"
              [style.visibility]="
                liveCounts.count('isForRent', true) === undefined ? 'hidden' : 'visible'
              "
              >({{ liveCounts.count('isForRent', true) }})</small
            ></label
          >
          <input
            type="radio"
            id="switch_left"
            name="isForRent"
            [value]="false"
            formControlName="isForRent"
            (click)="toggleIsRent(false)"
          />
          <label for="switch_left"
            ><span class="sale-option-label">{{ 'FOR_SALE' | translate }}</span>
            <small
              class="search-inline-count px-2"
              [style.visibility]="
                liveCounts.count('isForRent', false) === undefined ? 'hidden' : 'visible'
              "
              >({{ liveCounts.count('isForRent', false) }})</small
            ></label
          >
        </div>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="models"
          facetDomain="CAR"
          [facetForm]="searchForm"
          id="brandSelect"
          class="required multi-line-select"
          [items]="categories.brands"
          formControlName="models"
          placeholder="{{ 'CAR_SEARCH_MODEL' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <input
          formControlName="name"
          type="text"
          class="form-control"
          highlightIfHasValue
          placeholder="{{ 'CAR_SEARCH_NAME' | translate }}"
        />
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-md-4 col-12 text-light range-count-heading"
            ><span>{{ 'CAR_SEARCH_KMS' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('kilometers') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('kilometers') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT'
                    | translate: { count: liveCounts.rangeTotal('kilometers') })
              "
              >({{ liveCounts.rangeTotal('kilometers') ?? '' }})</small
            ></span
          >
          <div class="col-md-4 col-6">
            <div class="input-group">
              <input
                type="text"
                id="kilometersFrom"
                formControlName="kilometersFrom"
                class="form-control no-spinner"
                min="1"
                max="4000000"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text"><i class="bi bi-speedometer"></i></span>
            </div>
          </div>
          <div class="col-md-4 col-6">
            <div class="input-group">
              <input
                type="text"
                id="kilometersTo"
                formControlName="kilometersTo"
                class="form-control no-spinner"
                min="5"
                max="5000000"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text"><i class="bi bi-speedometer"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-md-4 col-12 text-light range-count-heading"
            ><span>{{ 'CAR_SEARCH_PRICE' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('price') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('price') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT' | translate: { count: liveCounts.rangeTotal('price') })
              "
              >({{ liveCounts.rangeTotal('price') ?? '' }})</small
            ></span
          >
          <div class="col-md-4 col-6">
            <div class="input-group">
              <input
                type="text"
                id="priceFrom"
                formControlName="priceFrom"
                class="form-control no-spinner"
                min="0"
                max="4000000"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">$</span>
            </div>
          </div>
          <div class="col-md-4 col-6">
            <div class="input-group">
              <input
                type="text"
                id="priceTo"
                formControlName="priceTo"
                class="form-control no-spinner"
                min="10"
                max="50000000"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">$</span>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <app-tri-state-checkbox formControlName="isInstallmentAvailable"
            [matchCount]="liveCounts.count('isInstallmentAvailable')" [label]="'PAY_IN_INSTALLMENTS' | translate" />
        </div>
        <label class="d-flex align-items-center gap-2 text-light mt-2">
          <input type="checkbox" class="form-check-input m-0" formControlName="onlyWithPrice" />
          <span>{{ 'SEARCH_ONLY_WITH_PRICE' | translate }}</span>
        </label>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="bodyTypes"
          facetDomain="CAR"
          [facetForm]="searchForm"
          id="bodyTypeSelect"
          class="required multi-line-select"
          [items]="categories.bodyTypes"
          formControlName="bodyTypes"
          placeholder="{{ 'CAR_SEARCH_BODY' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="fuelTypes"
          facetDomain="CAR"
          [facetForm]="searchForm"
          #fuelTypes
          class="required multi-line-select"
          [items]="categories.fuelTypes"
          formControlName="fuelTypes"
          placeholder="{{ 'CAR_SEARCH_FUEL' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-4 text-light range-count-heading"
            ><span>{{ 'CAR_SEARCH_YEAR' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('year') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('year') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT' | translate: { count: liveCounts.rangeTotal('year') })
              "
              >({{ liveCounts.rangeTotal('year') ?? '' }})</small
            ></span
          >
          <div class="col-4">
            <input
              id="yearFrom"
              type="number"
              inputmode="numeric"
              formControlName="yearFrom"
              class="form-control no-spinner"
              min="1930"
              [max]="maxYear"
              placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
              highlightIfHasValue
            />
          </div>
          <div class="col-4">
            <input
              type="number"
              inputmode="numeric"
              id="yearTo"
              formControlName="yearTo"
              class="form-control no-spinner"
              min="1930"
              [max]="maxYear"
              placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
              highlightIfHasValue
            />
          </div>
        </div>
      </div>
      <!-- Advanced fields (collapsed by default) -->
      @if (advancedVisible) {
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-md-4 col-12 text-light range-count-heading"
              ><span>{{ 'CAR_SEARCH_PS' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('performance') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('performance') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('performance') })
                "
                >({{ liveCounts.rangeTotal('performance') ?? '' }})</small
              ></span
            >
            <div class="col-md-4 col-6">
              <div class="input-group">
                <input
                  type="text"
                  id="performanceFrom"
                  formControlName="performanceFrom"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text">
                  <img src="icons/hp.png" width="30" height="22" />
                </span>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="input-group">
                <input
                  type="text"
                  id="performanceTo"
                  formControlName="performanceTo"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text">
                  <img src="icons/hp.png" width="30" height="22" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="colors"
            facetDomain="CAR"
            [facetForm]="searchForm"
            id="colorSelect"
            class="required multi-line-select"
            [items]="categories.colors"
            formControlName="colors"
            placeholder="{{ 'CAR_SEARCH_COLOR' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="interiorColors"
            facetDomain="CAR"
            [facetForm]="searchForm"
            id="interiorColorSelect"
            class="required multi-line-select"
            [items]="categories.colors"
            formControlName="interiorColors"
            placeholder="{{ 'CAR_SEARCH_INTERIOR_COLOR' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="seatCovers"
            facetDomain="CAR"
            [facetForm]="searchForm"
            id="seatCovers"
            class="required multi-line-select"
            [items]="categories.carSeatCovers"
            formControlName="seatCovers"
            placeholder="{{ 'CAR_NEW_SELECT_SEAT_COVER' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'CAR_SEARCH_SEAT' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('seat') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('seat') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('seat') })
                "
                >({{ liveCounts.rangeTotal('seat') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="seatFrom"
                  formControlName="seatFrom"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text">
                  <img src="icons/car-seat.png" width="22" height="18" />
                </span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="seatTo"
                  formControlName="seatTo"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text">
                  <img src="icons/car-seat.png" width="22" height="18" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'CAR_SEARCH_DOOR' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('door') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('door') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('door') })
                "
                >({{ liveCounts.rangeTotal('door') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="doorFrom"
                  formControlName="doorFrom"
                  class="form-control"
                  min="1"
                  max="8"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text">
                  <img src="icons/car-door.png" width="22" height="18" />
                </span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="doorTo"
                  formControlName="doorTo"
                  class="form-control"
                  min="1"
                  max="8"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text">
                  <img src="icons/car-door.png" width="22" height="18" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'CAR_SEARCH_WEIGHT' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('weight') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('weight') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('weight') })
                "
                >({{ liveCounts.rangeTotal('weight') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <input
                type="number"
                id="weightFrom"
                formControlName="weightFrom"
                class="form-control"
                min="1"
                max="20000"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                highlightIfHasValue
              />
            </div>
            <div class="col-4">
              <input
                type="number"
                id="weightTo"
                formControlName="weightTo"
                class="form-control"
                min="1"
                max="16"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                highlightIfHasValue
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'CAR_SEARCH_CYLINDER' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('cylinder') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('cylinder') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('cylinder') })
                "
                >({{ liveCounts.rangeTotal('cylinder') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <input
                type="number"
                id="cylinderFrom"
                formControlName="cylinderFrom"
                class="form-control"
                min="1"
                max="8"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                highlightIfHasValue
              />
            </div>
            <div class="col-4">
              <input
                type="number"
                id="cylinderTo"
                formControlName="cylinderTo"
                class="form-control"
                min="1"
                max="8"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                highlightIfHasValue
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="driveTypes"
            facetDomain="CAR"
            [facetForm]="searchForm"
            id="driveTypes"
            class="required multi-line-select"
            [items]="categories.carDriveTypes"
            formControlName="driveTypes"
            placeholder="{{ 'CAR_NEW_SELECT_DRIVE_TYPE' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="conditions"
            facetDomain="CAR"
            [facetForm]="searchForm"
            #conditions
            class="required multi-line-select"
            [items]="categories.conditions"
            formControlName="conditions"
            placeholder="{{ 'CAR_SEARCH_CONDITION' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="carUseTypes"
            facetDomain="CAR"
            [facetForm]="searchForm"
            #carUseTypes
            class="required multi-line-select"
            [items]="categories.carUseTypes"
            formControlName="carUseTypes"
            placeholder="{{ 'CAR_SEARCH_USE_TYPE' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div *hasRole="[roles.Admin, roles.Editor]" class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="statuses"
            facetDomain="CAR"
            [facetForm]="searchForm"
            #statuses
            class="required multi-line-select"
            [items]="categories.statuses"
            formControlName="statuses"
            placeholder="{{ 'CAR_SEARCH_STATUS' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-12">
          <div class="row ms-4">
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('isManulaGear')"
                                      formControlName="isManulaGear"
                                      label="{{ 'CAR_SEARCH_GEAR' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('isAccident')"
                                      formControlName="isAccident"
                                      label="{{ 'CAR_SEARCH_ACCIDENT' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasSunroof')"
                                      formControlName="hasSunroof"
                                      label="{{ 'CAR_NEW_SELECT_SUNROOF' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasPanoramicSunroof')"
                                      formControlName="hasPanoramicSunroof"
                                      label="{{ 'CAR_NEW_SELECT_PANORAMIC_SUNROOF' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('withWarranty')"
                                      formControlName="withWarranty"
                                      label="{{ 'CAR_SEARCH_WARRANTY' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasFrontCamera')"
                                      formControlName="hasFrontCamera"
                                      label="{{ 'CAR_HAS_FRONT_CAMERA' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasRearCamera')"
                                      formControlName="hasRearCamera"
                                      label="{{ 'CAR_HAS_REAR_CAMERA' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasCentralLock')"
                                      formControlName="hasCentralLock"
                                      label="{{ 'CAR_HAS_CENTRAL_LOCK' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasKeylessEntry')"
                                      formControlName="hasKeylessEntry"
                                      label="{{ 'CAR_HAS_KEYLESS_ENTRY' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasPushButtonStart')"
                                      formControlName="hasPushButtonStart"
                                      label="{{ 'CAR_HAS_PUSH_BUTTON_START' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasSportSeats')"
                                      formControlName="hasSportSeats"
                                      label="{{ 'CAR_HAS_SPORT_SEATS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasCruiseControl')"
                                      formControlName="hasCruiseControl"
                                      label="{{ 'CAR_HAS_CRUISE_CONTROL' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasAbs')"
                                      formControlName="hasAbs"
                                      label="{{ 'CAR_HAS_ABS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasAlarmSystem')"
                                      formControlName="hasAlarmSystem"
                                      label="{{ 'CAR_HAS_ALARM_SYSTEM' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasSeatHeating')"
                                      formControlName="hasSeatHeating"
                                      label="{{ 'CAR_HAS_SEAT_HEATING' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasVentilatedSeats')"
                                      formControlName="hasVentilatedSeats"
                                      label="{{ 'CAR_HAS_VENTILATED_SEATS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasElectricSeats')"
                                      formControlName="hasElectricSeats"
                                      label="{{ 'CAR_HAS_ELECTRIC_SEATS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasMemorySeats')"
                                      formControlName="hasMemorySeats"
                                      label="{{ 'CAR_HAS_MEMORY_SEATS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasMassageSeats')"
                                      formControlName="hasMassageSeats"
                                      label="{{ 'CAR_HAS_MASSAGE_SEATS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasSteeringWheelHeating')"
                                      formControlName="hasSteeringWheelHeating"
                                      label="{{ 'CAR_HAS_STEERING_WHEEL_HEATING' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasElectricWindows')"
                                      formControlName="hasElectricWindows"
                                      label="{{ 'CAR_HAS_ELECTRIC_WINDOWS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasElectricMirrors')"
                                      formControlName="hasElectricMirrors"
                                      label="{{ 'CAR_HAS_ELECTRIC_MIRRORS' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasReserveTire')"
                                      formControlName="hasReserveTire"
                                      label="{{ 'CAR_HAS_RESERVE_TIRE' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasWirelessCharging')"
                                      formControlName="hasWirelessCharging"
                                      label="{{ 'CAR_HAS_WIRELESS_CHARGING' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasInfotainmentScreen')"
                                      formControlName="hasInfotainmentScreen"
                                      label="{{ 'CAR_HAS_INFOTAINMENT_SCREEN' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('has220VoltOutlet')"
                                      formControlName="has220VoltOutlet"
                                      label="{{ 'CAR_HAS_220_VOLT_OUTLET' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('has360Camera')"
                                      formControlName="has360Camera"
                                      label="{{ 'CAR_HAS_360_CAMERA' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasFrontSensor')"
                                      formControlName="hasFrontSensor"
                                      label="{{ 'CAR_HAS_FRONT_SENSOR' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasRearSensor')"
                                      formControlName="hasRearSensor"
                                      label="{{ 'CAR_HAS_REAR_SENSOR' | translate }}">
              </app-tri-state-checkbox>
            </div>
            <div class="col-12 col-md-4 col-sm-6 pb-3"
                 [ngClass]="isArabic ? 'justify-content-between d-flex' : ''">
              <app-tri-state-checkbox [matchCount]="liveCounts.count('hasElectricTailgate')"
                                      formControlName="hasElectricTailgate"
                                      label="{{ 'CAR_HAS_ELECTRIC_TAILGATE' | translate }}">
              </app-tri-state-checkbox>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="col-md-12" [ngClass]="isArabic ? 'text-start' : 'text-end'">
      <button
        type="button"
        class="btn btn-primary bg-black text-primary mx-1"
        (click)="toggleAdvanced()"
      >
        {{ advancedVisible ? ('CAR_SEARCH_LESS' | translate) : ('CAR_SEARCH_MORE' | translate) }}
        @if (usedCriteriaCount > 0) {
          <span class="badge text-bg-primary"> {{ usedCriteriaCount }}</span>
        }
      </button>
      <button type="submit" class="btn btn-primary">{{ 'SEARCH_BUTTON' | translate }}</button>
      <button type="button" class="btn btn-secondary bg-black text-primary mx-1" (click)="reset()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="mt-2" [ngClass]="isArabic ? 'text-start' : 'text-end'">
      <app-save-search [form]="searchForm" domain="CAR" />
    </div>
  </form>
}

@if ((loadingResult$ | async) && !isMapView()) {
  <div role="status" class="text-center my-3"><app-loading></app-loading></div>
}
<div class="container-fluid">
  <app-car-search-result
    [mapParameters]="mapParameters"
    (mapChanged)="mapChanged($event)"
    (onListView)="clearMapData()"
  ></app-car-search-result>
</div>
